module.exports = __webpack_public_path__ + "img/开封市-c.fcf0fcc9.png";